import { updateDiagramLoopDashes, getDiagramLoopDashes } from '@process-advisor/process-miner/processMiner/processMiner';

type LoopDashesProps = {
    loopDashes?: boolean;
}

export const changeLoopDashes = ({ loopDashes }: LoopDashesProps) =>
    updateDiagramLoopDashes({ loopDashes });

export const getLoopDashes = (): LoopDashesProps => getDiagramLoopDashes();
